// extracted by mini-css-extract-plugin
export default {"bar":"components-general-loading-bar-module__bar","pulse":"components-general-loading-bar-module__pulse"};